import PropTypes from 'prop-types';

import { useContext } from 'react';

import MaterialsCaptureContext from '../../context/MaterialsCaptureContext';

import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";

const SterilefiltrationForm = ({ data }) => {
  const { handleInputChange, formErrors } = useContext(MaterialsCaptureContext);

  return(
    <Grid container spacing={1} mt={1}>
      <Grid item xs={6}>
        <TextField
          varient="outlined"
          label="Sterile filter manufacturer"
          name={`sterile_filter_manufacturer-${data?.index}`}
          value={data?.sterile_filter_manufacturer}
          onChange={e => 
            handleInputChange(
              e, data?.index, 'sterile_filter_manufacturer', e.target.value
            )
          }
          helperText={formErrors[`sterile_filter_manufacturer-${data?.index}`]}
          error={`sterile_filter_manufacturer-${data?.index}` in formErrors}
          fullWidth
        />
      </Grid>

      <Grid item xs={6}>
        <TextField
          varient="outlined"
          label="Sterile filter product code"
          name={`sterile_filter_product_code-${data?.index}`}
          value={data?.sterile_filter_product_code}
          onChange={e => 
            handleInputChange(
              e, data?.index, 'sterile_filter_product_code', e.target.value
            )
          }
          helperText={formErrors[`sterile_filter_product_code-${data?.index}`]}
          error={`sterile_filter_product_code-${data?.index}` in formErrors}
          fullWidth
        />
      </Grid>

      <Grid item xs={6}>
        <TextField
          varient="outlined"
          label="Sterile filter pore diameter (µm)"
          name={`sterile_filter_pore_diameter-${data?.index}`}
          value={data?.sterile_filter_pore_diameter}
          onChange={e => 
            handleInputChange(
              e, data?.index, 'sterile_filter_pore_diameter', e.target.value
            )
          }
          helperText={formErrors[`sterile_filter_pore_diameter-${data?.index}`]}
          error={`sterile_filter_pore_diameter-${data?.index}` in formErrors}
          type='number'
          fullWidth
        />
      </Grid>

      <Grid item xs={6}>
        <TextField
          varient="outlined"
          label="Sterile filter pore membrane material"
          name={`sterile_filter_pore_membrane_material-${data?.index}`}
          value={data?.sterile_filter_pore_membrane_material}
          onChange={e => 
            handleInputChange(
              e, data?.index, 'sterile_filter_pore_membrane_material', e.target.value
            )
          }
          helperText={
            formErrors[`sterile_filter_pore_membrane_material-${data?.index}`]
          }
          error={
            `sterile_filter_pore_membrane_material-${data?.index}` in formErrors
          }
          fullWidth
        />
      </Grid>
    </Grid>
  );
};

SterilefiltrationForm.propTypes = {
  data: PropTypes.object.isRequired,
};

export default SterilefiltrationForm;